export default {
  // Page title
  title: 'Create Activity',
  editTitle: 'Edit Activity',
  // Step titles
  step1: 'Basic Info',
  step2: 'Activity Scope',
  step3: 'Activity Prizes',
  step4: 'Activity Strategy',
  // Step 1 - Basic Info
  activityName: 'Activity Name',
  activityNameRequired: 'Please enter activity name',
  activityNamePlaceholder: 'Please enter activity name',
  activityTime: 'Activity Period',
  activityTimeRequired: 'Please select activity period',
  startTime: 'Start Time',
  endTime: 'End Time',
  activityTemplate: 'Activity Template',
  activityTemplateRequired: 'Please select activity template',
  activityTemplatePlaceholder: 'Please select activity template',
  addTemplate: '+Activity Template',
  activityRule: 'Activity Rule',
  rulePlaceholder: 'Please enter activity rule',
  activityRemark: 'Activity Remark',
  remarkPlaceholder: 'Please enter activity remark',
  // Step 2 - Activity Scope
  addCode: 'Add QR Code',
  addCodeTitle: 'Add QR Code',
  selectCodePlaceholder: 'Please select QR code',
  codeEmptyText: 'No QR code data',
  codeBatch: 'Code Batch',
  codeRange: 'QR Code Range',
  codeCount: 'QR Code Count',
  scopeRemark: 'Scope Remark',
  colAction: 'Action',
  deleteCode: 'Delete',
  codeBatchRequired: 'Please select code batch',
  codeBatchPlaceholder: 'Please select code batch',
  selectCodeBatch: 'Select Code Batch',
  codeRangeType: 'QR Code Range',
  codeRangeTypeRequired: 'Please select QR code range type',
  rangeAll: 'Full Batch',
  rangePartial: 'Partial',
  rangePartialSerial: 'Partial (Serial Range)',
  rangePartialId: 'Partial (ID Range)',
  codeRangeRequired: 'Please enter QR code range',
  serialRange: 'Serial Range',
  idRange: 'QR Code ID Range',
  serialStartPlaceholder: 'Start Serial',
  serialEndPlaceholder: 'End Serial',
  idStartPlaceholder: 'Start ID',
  idEndPlaceholder: 'End ID',
  rangeStartPlaceholder: 'Start No.',
  rangeEndPlaceholder: 'End No.',
  scopeRemarkPlaceholder: 'Please enter scope remark',
  invalidRange: 'End number must be greater than start number',
  confirmDeleteRange: 'Are you sure to delete this range?',
  codeBatchNo: 'Batch No.',
  codeBatchName: 'Batch Name',
  // Step 3 - Activity Prizes
  addPrize: 'Add Prize',
  addPrizeTitle: 'Add Prize',
  editPrizeTitle: 'Edit Prize',
  editPrize: 'Edit',
  deletePrize: 'Delete',
  confirmDeletePrize: 'Are you sure to delete this prize?',
  prizeEmptyText: 'No prize data',
  prizeName: 'Prize Name',
  prizeNameRequired: 'Please enter prize name',
  prizeNamePlaceholder: 'Please enter prize name',
  prizeProbability: 'Winning Probability',
  prizeProbabilityPlaceholder: 'Please enter winning probability',
  prizeCount: 'Prize Count',
  prizeCountPlaceholder: 'Please enter prize count',
  prizeContent: 'Prize Content',
  pointsLabel: 'Points',
  giftLabel: 'Gift',
  strategyOnly: 'Strategy Only',
  prizeImage: 'Prize Image',
  prizePoints: 'Points',
  prizeGift: 'Gift Name',
  prizeGiftPlaceholder: 'Please select a gift',
  prizeIcon: 'Prize Icon',
  prizeIconRequired: 'Please upload prize icon',
  prizePointsPlaceholder: 'Please enter points amount',
  prizeProbabilityRequired: 'Please enter winning probability',
  prizeCountRequired: 'Please enter prize quantity',
  prizeContentRequired: 'Please select at least one prize content',
  prizeGiftRequired: 'Please select a gift',
  prizePointsRequired: 'Please enter points amount',
  selectGift: 'Select Gift',
  giftNameCol: 'Gift Name',
  giftCategoryCol: 'Gift Category',
  // Step 4 - Activity Strategy
  strategyPriority: 'Strategy Priority',
  addStrategy: 'Add Strategy',
  addStrategyTitle: 'Add Strategy',
  editStrategyTitle: 'Edit Strategy',
  editStrategy: 'Edit',
  deleteStrategy: 'Delete',
  confirmDeleteStrategy: 'Are you sure to delete this strategy?',
  strategyEmptyText: 'No strategy data',
  strategyStatus: 'Strategy Status',
  strategyName: 'Strategy Name',
  strategyNameRequired: 'Please enter strategy name',
  strategyNamePlaceholder: 'Please enter strategy name',
  strategyDetail: 'Strategy Detail',
  specifyCountry: 'Specify Country/Region',
  specifyCountryPlaceholder: 'Please enter country/region',
  strategyType: 'Strategy Type',
  strategyRules: 'Strategy Rules',
  ruleType: 'Rule Type',
  ruleContent: 'Rule Content',
  ruleEmptyText: 'No strategy rules',
  ruleFormPlaceholder: 'Rule configuration to be added',
  typeCountry: 'Country/Region Award',
  typeCountryDesc: 'Award users in specified region or GPS range',
  typeMemberLevel: 'Member Level Award',
  typeMemberLevelDesc: 'Award users with specified member level',
  typeUserLimit: 'User Limit Award',
  typeUserLimitDesc: 'Max N wins per user in activity period',
  typeTimePeriod: 'Time Period Award',
  typeTimePeriodDesc: 'Award only during specified time periods',
  memberLevel: 'Member Level',
  memberLevelPlaceholder: 'Please select member level',
  countryRegion: 'Country/Region',
  countryPlaceholder: 'Please select country',
  regionPlaceholder: 'Please select region',
  timePeriod: 'Time Period',
  timePeriods: 'Time Periods',
  currentActivityPeriod: 'Current Activity Period',
  userLimitCount: 'User Limit Count',
  nthLabel: 'No.',
  scanParticipate: 'scan(s) to participate',
  timeType: 'Time Type',
  timeTypeDaily: 'Daily',
  timeTypeWeekly: 'Weekly',
  timeTypeCustom: 'Custom Date Range',
  selectWeekDays: 'Select Days',
  selectDateRange: 'Select Date Range',
  startDate: 'Start Date',
  endDate: 'End Date',
  weekDayMon: 'Mon',
  weekDayTue: 'Tue',
  weekDayWed: 'Wed',
  weekDayThu: 'Thu',
  weekDayFri: 'Fri',
  weekDaySat: 'Sat',
  weekDaySun: 'Sun',
  // Strategy Award Configuration
  strategyAwards: 'Strategy Awards',
  awardConfigHint: 'Select awards to associate and configure winning rate & quantity limits',
  restrictAwardNum: 'Award Quantity Limit',
  totalLimit: 'Total Limit',
  dailyLimit: 'Daily Limit',
  awardAtLeastOne: 'Please select at least one award',
  noAwardsAvailable: 'No awards available. Please add awards in Step 3 first.',
  awardNumExceedTotal: '"{name}" total limit cannot exceed the award quantity ({total})',
  dailyNumExceedTotal: '"{name}" daily limit cannot exceed the strategy total limit ({total})',
};
